/**
 * Saves a base64 payload the API returned as a file.
 *
 * The portal streams documents through the API rather than handing out signed
 * storage URLs, so that a carrier's access is re-checked on every fetch instead
 * of at the moment a link was minted. The cost is that the browser has to turn
 * the bytes back into a download itself.
 */
export function downloadBase64File(
  fileName: string,
  contentType: string | undefined,
  base64Content: string,
): void {
  const binary = atob(base64Content);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  const blob = new Blob([bytes], {
    type: contentType ?? "application/octet-stream",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Freeing the object URL immediately would race the download in some
  // browsers, so it waits a tick.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
